import React from "react"
import getValue from "get-value"
import Slider from "react-slick"
import { getImageData } from "@utils/image"
import { GatsbyImage } from "gatsby-plugin-image"
import RichText from "@components/rich-text"
import CarouselDots from "../carousel/dots"
import { useIsMobile } from "@src/utils/general"
import useCarousel from "@src/hooks/useCarousel"

const Testimonials = ({ _id, carouselSlides, quotes, sliderSettings: settings, isSlider }) => {
  const isMobile = useIsMobile();
  const { hoverAnimation } = useCarousel();

  if (isSlider) {
    const sliderSettings = {
      ...settings,
      touchThreshold: 10,
      animateOnHover: true,
      appendDots: (dots) => (<CarouselDots dots={dots} />),
      slidesToShow: settings?.slidesToShow?.desktop,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: settings?.slidesToShow?.mobile,
            variableWidth: false,
          }
        }
      ],
      afterChange: () => {
        settings?.animateOnHover &&
          !isMobile &&
          settings?.numberOfSlides > 1 &&
          hoverAnimation()
      }
    };
  
    return (
      <Slider {...sliderSettings} className="w-full slider overflow-hidden" id={_id}>
        {carouselSlides?.map(testimonial => (
          <Testimonial key={testimonial._key} {...testimonial} />
        ))}
      </Slider>
    )
  }

  return (
    <div id={_id} className="">
      <div className="grid gap-y-12 lg:grid-cols-3 lg:gap-10">
        {quotes?.map(testimonial => (
          <Testimonial key={testimonial._key} {...testimonial} isSlider={isSlider} />
        ))}
      </div>
  </div>
  )
}

const Testimonial = ({ content, text, credit, author, image, isSlider }) => {
  const imageTitle = getValue(image, "title", { default: credit })
  const imageAssetId = getValue(image, "asset._ref") || getValue(image, "image.asset._ref")
  const imageData = getImageData(imageAssetId, {
    width: 500,
    height: 500,
    fit: "crop",
  })

  return (
    <div className={`text-center flex flex-col align-center justify-center h-full ${isSlider ? 'py-10 md:py-20' : ''}`}>
      {imageData && (
        <div className="max-w-xs !mx-auto mb-8 overflow-hidden rounded-full lg:mb-12">
          <GatsbyImage
            className="object-cover w-full h-full ml-auto"
            image={imageData}
            alt={imageTitle}
            fadeIn={false}
            loading="eager"
          />
        </div>
      )}
      {text && <RichText className="flex justify-center" text={text}></RichText>}
      {content && <RichText 
        className="flex justify-center mb-2 subheadline" 
        paragraphClassName="!max-w-[90%] mx-auto"
        childrenHTML={content?.replace(/\n/g, '<br>')}
      ></RichText>}
      <p className="text-sm antialiased not-italic leading-5 text-darker-gray font-medium">
        - {credit || author}
      </p>
    </div>
  )
}

export default Testimonials
